export default __webpack_public_path__ + "static/media/expo2.07c5c2ca.jpg";